import { useAuth0 } from '@auth0/auth0-react'
import {
  Box,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  Typography,
} from '@mui/material'
import Cookies from 'js-cookie'
import { useState } from 'react'
import { MdLogout } from 'react-icons/md'
import { useParams } from 'react-router'

import { useAppDispatch } from '@/hooks/redux'
import { persistor } from '@/store'
import { apiService, useLazyClearSessionQuery } from '@/store/apiService'
import { resetHeaders } from '@/utils/httpService'

import PlanLanding from './PlanLanding'
import ProfileLandingForm from './ProfileLandingForm'

const BasicInfo = () => {
  const { step } = useParams()
  const dispatch = useAppDispatch()
  const { logout } = useAuth0()
  const [clearSession] = useLazyClearSessionQuery()
  const [loggingOut, setLoggingOut] = useState(false)

  const logoutWithRedirect = async () => {
    try {
      setLoggingOut(true)
      await clearSession('logout')

      dispatch(apiService.util.resetApiState())

      await persistor.purge()

      const cookies = Cookies.get()
      Object.keys(cookies).forEach((cookieName) => {
        Cookies.remove(cookieName)
      })

      window.localStorage.clear()
      window.sessionStorage.clear()

      resetHeaders()

      logout({
        logoutParams: { returnTo: window.location.origin },
      })
    } catch (error) {
      console.error('Error during logout:', error)
    }
  }

  return (
    <Box height="100vh" display="flex" flexDirection="column" width={'100%'}>
      <Card
        sx={{
          backgroundColor: step === 'profile' ? '#rgb(41,41,41)' : '#000',
          color: 'white',
          height: '100%',
          overflowY: 'auto',
        }}
      >
        <ButtonGroup variant="contained" fullWidth sx={{ boxShadow: 'none' }}>
          <Button
            disabled={step === 'plans'}
            sx={{
              backgroundColor: step === 'profile' ? '#90CAF9' : '#90CAF950',
            }}
          />
          <Button
            disabled={step === 'profile'}
            sx={{
              backgroundColor: step === 'plans' ? '#90CAF9' : '#90CAF950',
            }}
          />
        </ButtonGroup>

        <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            sx={{
              ...(step === 'profile'
                ? {
                    width: {
                      xs: '100%',
                      sm: '100%',
                      md: '80%',
                      lg: 'clamp(50px, 30vw + 10%, 100%)',
                    },
                    mx: 'auto',
                  }
                : {}),
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                width: '100%',
                maxWidth: '90%',
                position: 'relative',
              }}
            >
              <Button
                variant="outlined"
                onClick={logoutWithRedirect}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  fontWeight: 500,
                  fontSize: '15px',
                  color: '#8ec9f6',
                  borderColor: 'transparent',
                  textTransform: 'none',
                  position: 'relative',
                  left:
                    step === 'profile'
                      ? { xs: '28px', sm: '28px', md: '20rem' }
                      : { xs: '28px', sm: '28px' },
                  top: { xs: '-4rem', sm: '-3rem', md: '0rem' },
                  '&:hover': {
                    borderColor: 'transparent',
                    backgroundColor: 'transparent',
                  },
                }}
              >
                <MdLogout size={20} />
                LOG OUT
              </Button>
            </Box>

            <Typography
              sx={{
                fontSize: '36px',
                fontWeight: 600,
                display: 'flex',
                justifyContent: 'center',
                letterSpacing: '-0.72px',
                mb: 4,
              }}
            >
              {step === 'profile' ? 'Before you start...' : 'Pricing'}
            </Typography>

            {!loggingOut && step === 'profile' && (
              <ProfileLandingForm onLogout={logoutWithRedirect} />
            )}
            {!loggingOut && step === 'plans' && <PlanLanding />}
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}

export default BasicInfo
